/* 
 * phina.form.js 0.2.0
 * 
 * MIT Licensed
 * 
 * Copyright (C) 2019 Amatsuti
 */


'use strict';


/**
 * @class phina.accessory.DisappearEvent
 * @extends phina.accessory.Accessory
 */
phina.define('phina.accessory.DisappearEvent', {
  superClass: 'phina.accessory.Accessory',
  /**
   * @constructor
   */
  init: function(target) {
    this.superInit(target);
    this.range = null;
    
    this.on('attached', function() {
      var self=this;
      if(self.target.parent){
        self.range = self.target.parent;
      }else{
        self.target.on('added', function(){
          self.range = self.target.parent;
        });
      }
    });

  },

  update: function(){
    var target = this.target;
    var range = this.range;
    if(target.top > range.height/2 || target.left > range.width/2
    || target.bottom < -range.height/2 || target.right < -range.width/2){
      target.flare('disappear');
    }
  },

  enable: function() {
    this._enable = true;
  },

});




phina.namespace(function() {

  /**
   * @class phina.accessory.Draggable2
   * Draggable2
   * @extends phina.accessory.Accessory
   */
  phina.define('phina.accessory.Draggable2', {
    superClass: 'phina.accessory.Accessory',

    /**
     * @constructor
     */
    init: function(target) {
      this.superInit(target);

      this.initialPosition = phina.geom.Vector2(0, 0);
      var self = this;

      this.vertical = true;
      this.horizontal = true;

      this.on('attached', function() {
        this.target.setInteractive(true);

        this._dragging = false;

        this.target.on('pointstart', function(e) {
          if (phina.accessory.Draggable2._lock) return ;

          this._dragging = true;
          self.initialPosition.x = this.x;
          self.initialPosition.y = this.y;
          self.flare('dragstart');
          this.flare('dragstart');
        });
        this.target.on('pointmove', function(e) {
          if (!this._dragging) return ;

          if(self.horizontal){
            this.x += e.pointer.dx;
            if(this.x < -this.parent.width/2){
              this.x = -this.parent.width/2;
            }
            if(this.x > this.parent.width/2){
              this.x = this.parent.width/2;
            }
          }
          if(self.vertical){
            this.y += e.pointer.dy;
            if(this.y < -this.parent.height/2){
              this.y = -this.parent.height/2;
            }
            if(this.y > this.parent.height/2){
              this.y = this.parent.height/2;
            }
          }
          self.flare('drag');
          this.flare('drag');
        });

        this.target.on('pointend', function(e) {
          if (!this._dragging) return ;

          this._dragging = false;
          self.flare('dragend');
          this.flare('dragend');
        });
      });
    },

    back: function(time, easing) {
      if (time) {
        var t = this.target;
        t.setInteractive(false);
        var tweener = phina.accessory.Tweener().attachTo(t);
        tweener
          .to({
            x: this.initialPosition.x,
            y: this.initialPosition.y,
          }, time, easing || 'easeOutElastic')
          .call(function() {
            tweener.remove();

            t.setInteractive(true);
            this.flare('backend');
          }, this);
      }
      else {
        this.target.x = this.initialPosition.x;
        this.target.y = this.initialPosition.y;
        this.flare('backend');
      }
    },

    enable: function() {
      this._enable = true;
    },

    _static: {
      _lock: false,
      lock: function() {
        this._lock = true;
      },
      unlock: function() {
        this._lock = false;
      },
    }

  });

  // phina.app.Element.prototype.getter('draggable', function() {
  //   if (!this._draggable) {
  //     this._draggable = phina.accessory.Draggable().attachTo(this);
  //   }
  //   return this._draggable;
  // });
  
});

/**
 * @class phina.accessory.Flickable2
 * @extends phina.accessory.Accessory
 */
phina.define('phina.accessory.Flickable2', {
  superClass: 'phina.accessory.Accessory',
  /**
   * @constructor
   */
  init: function(target) {
    this.superInit(target);

    this.initialPosition = phina.geom.Vector2(0, 0);
    var self = this;

    this.friction = 0.9;
    this.velocity = phina.geom.Vector2(0, 0);
    this.vertical = true;
    this.horizontal = true;
    this._enable = true;
    this.valid = false;
    this.actFlag = false;

    this.cacheList = [];

    this.on('attached', function() {
      this.target.setInteractive(true);

      this.target.on('pointstart', function(e) {
        if(!self._enable){ return; }
        self.initialPosition.set(this.x, this.y);
        self.velocity.set(0, 0);
        self.valid = true;
        self.actFlag = true;
        self.flare('dragstart');
        this.flare('dragstart');
      });
      this.target.on('pointstay', function(e) {
        if(!self._enable || !self.valid){ return; }
        if (self.horizontal) {
          this.x += e.pointer.dx;
          if(this.x < -this.parent.width/2){
            this.x = -this.parent.width/2;
          }
          if(this.x > this.parent.width/2){
            this.x = this.parent.width/2;
          }
        }
        if (self.vertical) {
          this.y += e.pointer.dy;
          if(this.y < -this.parent.height/2){
            this.y = -this.parent.height/2;
          }
          if(this.y > this.parent.height/2){
            this.y = this.parent.height/2;
          }
        }

        if (self.cacheList.length > 3) self.cacheList.shift();
        self.cacheList.push(e.pointer.deltaPosition.clone());
        var _e = {
          dx: e.pointer.dx, dy: e.pointer.dy,
          value: phina.geom.Vector2(e.pointer.dx,e.pointer.dy).length()
        };
        self.flare('drag', _e);
        this.flare('drag', _e);
      });

      this.target.on('pointend', function(e) {
        if(!self._enable || !self.valid){
          return;
        }
        self.valid = false;
        // 動きのある delta position を後ろから検索　
        var delta = self.cacheList.reverse().find(function(v) {
          return v.lengthSquared() > 10;
        });
        self.cacheList.clear();

        self.flare('dragend');
        this.flare('dragend');
        if (delta) {
          self.velocity.x = delta.x;
          self.velocity.y = delta.y;

          self.flare('flickstart', {
            direction: delta.normalize(),
          });
        }
        else {
          self.flare('flickcancel');
        }

        // self.flare('flick');
        // self.flare('flickend');
      });
    });
  },

  update: function(){
    if (!this.target || !this._enable) return ;
    let moved = false;

    this.velocity.x *= this.friction;
    this.velocity.y *= this.friction;

    if (this.horizontal) {
      this.target.position.x += this.velocity.x;
      if(this.target.position.x < -this.target.parent.width/2){
        this.target.position.x = -this.target.parent.width/2;
      }
      if(this.target.position.x > this.target.parent.width/2){
        this.target.position.x = this.target.parent.width/2;
      }
      if(this.velocity.x < -1 || this.velocity.x > 1){
        moved = true;
      }
    }
    if (this.vertical) {
      this.target.position.y += this.velocity.y;
      if(this.target.position.y < -this.target.parent.height/2){
        this.target.position.y = -this.target.parent.height/2;
      }
      if(this.target.position.y > this.target.parent.height/2){
        this.target.position.y = this.target.parent.height/2;
      }
      if(this.velocity.y < -1 || this.velocity.y > 1){
        moved = true;
      }
    }
    if(moved){
      this.flare('slip');
      this.target.flare('slip');
    }
    if(this.actFlag && !this.valid && !moved){
      this.actFlag = false;
      this.velocity.set(0,0);
      this.flare('sliped');
    }
  },

  cancel: function() {
    this.target.x = this.initialPosition.x;
    this.target.y = this.initialPosition.y;
    this.velocity.set(0, 0);

    // TODO: 
    // this.setInteractive(false);
    // this.tweener.clear()
    //     .move(this.initialX, this.initialY, 500, "easeOutElastic")
    //     .call(function () {
    //         this.setInteractive(true);
    //         this.fire(tm.event.Event("backend"));
    //     }.bind(this));
  },
  stop: function() {
    this.cacheList.clear();
    this.velocity.set(0, 0);
  },
  enable: function() {
    this._enable = true;
  },
  disable: function() {
    this.stop();
    this._enable = false;
  },
});


phina.namespace(function() {

  /**
   * @class phina.accessory.MouseWheelScrollable
   * @extends phina.accessory.Accessory
   */
  phina.define('phina.accessory.MouseWheelScrollable', {
    superClass: 'phina.accessory.Accessory',

    /**
     * @constructor
     */
    init: function(target) {
      this.superInit(target);

      let self = this;
      let hamster = phina.accessory.MouseWheelScrollable.hamster;
      if(hamster === null && !!Hamster){
        hamster = Hamster(phina.global.app.domElement);
      }
      this.vertical = true;
      this.horizontal = true;
      this.gain = 2.0;
      this._enable = true;
      this._wait = 0;

      this.on('attached', function(){
        this.target.setInteractive(true);    
        self._mousewheelscrolling = false;

        hamster.wheel(function(e, d, dx, dy){
          let t = self.target;
          if(!self._enable){ return; }
          if(self._wait){ self._wait-=1; return; }
          if(self._mousewheelscrolling){
            if(self.horizontal){
              t.x -= dx * self.gain;
              if(t.parent && t.x < -t.parent.width/2){
                t.x = -t.parent.width/2;
              }
              if(t.parent && t.x > t.parent.width/2){
                t.x = t.parent.width/2;
              }
            }
            if(self.vertical){
              t.y -= dy * self.gain;
              if(t.parent && t.y < -t.parent.height/2){
                t.y = -t.parent.height/2;
              }
              if(t.parent && t.y > t.parent.height/2){
                t.y = t.parent.height/2;
              }
            }
            var detail = {
              detail:e, d:d, dx:dx, dy:dy,
              overX:t.parent && (t.x==t.parent.width/2 || t.x==-t.parent.width/2),
              overY:t.parent && (t.y==t.parent.height/2 || t.y==-t.parent.height/2),
            };
            self.flare('scroll', detail);
            t.flare('scroll', detail);
          }
        })
  
        this.target.on('pointover', function(e){
          self._mousewheelscrolling = true;
        })
        this.target.on('pointout', function(e){
          self._mousewheelscrolling = false;
        })
  
      })

    },

    enable: function() {
      this._enable = true;
    },
    disable: function() {
      this._enable = false;
    },
    wait: function(num) {
      this._wait = num || 1;
    },

    _static: {
      hamster: null,
    }
  })

});


/**
 * @class phina.accessory.Scrollable
 * @extends phina.accessory.Accessory
 */
phina.define('phina.accessory.Scrollable2', {
  superClass: 'phina.accessory.Accessory',
  /**
   * @constructor
   */
  init: function(target, isScene) {
    this.superInit(target);

    this.on('attached', function() {
      var self=this;
      var x = isScene ? this.target.width/2 : 0;
      var y = isScene ? this.target.height/2 : 0;
      self.scrollelm = phina.display.RectangleShape({
        width: this.target.width, height: this.target.height,
        fill:'transparent', stroke:'transparent'
      }).on('added', function(){
        self.bk_x = x;
        self.bk_y = y;
        self.dr_y = 0;
      }).addChildTo(this.target).setPosition(x,y);
      self.scrollelm.setInteractive(true);

      self.scrollelm.flickable.enable();
      self.scrollelm.flickable.horizontal = false;
      self.flickstay=false;
      self.pointstay=false;
      self.scrollelm.on('pointstart', function(e){
        if(!self.flickstay){
          self.target.flare('scrollstart');
        }
        self.pointstay=true;
      });
      self.scrollelm.on('pointend', function(e){
        self.pointstay=false;
      });
      self.scrollelm.flickable.on('flickstart', function(e){
        self.flickstay=true;
      });
      self.scrollelm.flickable.on('flickcancel', function(e){
        if(!self.pointstay){
          self.target.flare('scrollend');
          self.scrollelm.flickable.velocity.set(0,0);
          self.flickstay=false;
        }
      });
    });
  },

  update: function(){
    var self = this;
    while(true){
      self.dr_y+=self.scrollelm.y-self.bk_y;
      self.scrollelm.y=self.bk_y;
      if(self.dr_y>=100){
        self.dr_y-=100;
        self.target.flare('scrolldown');
      }else if(self.dr_y<=-100){
        self.dr_y+=100;
        self.target.flare('scrollup');
      }else{
        break;
      }
    }
    if(self.flickstay && !self.pointstay
    && self.scrollelm.flickable.velocity.y<1
    && self.scrollelm.flickable.velocity.y>-1){
      self.target.flare('scrollend');
      self.scrollelm.flickable.velocity.set(0,0);
      self.flickstay=false;
    }
  },

  cancel: function() {
    this.scrollelm.flickable.cancel();
  },

  enable: function() {
    this._enable = true;
  },

});


/**
 * @class phina.asset.TextureFrame
 */
phina.define("phina.asset.TextureFrame", {
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.asset.TextureFrame.defaults);
    this.frame = [];

    var image = param.image;
    if (typeof image === 'string') {
      image = phina.asset.AssetManager.get('image', image);
    }

    (param.rows*param.cols).times(function(i){
      var r = param.rows;
      var c = param.cols;
      var x = i%c;
      var y = (i/c)|0;
      var w = param.width;
      var h = param.height;

      var texture = image.clone();
      var canvas = phina.graphics.Canvas().setSize(w,h);
      canvas.context.drawImage(
        texture.domElement, x*w,y*h, w,h, 0,0, w,h);
      texture.domElement = canvas.domElement;
      self.frame.push(texture);
    });

  },
  at: function(index){
    return this.frame[index];
  },
  _static: {
    defaults: {
      image: undefined,
      width:30, height:30,
      rows:1, cols:1,
    }
  }
});


/**
 * @class phina.display.BaseStackLayout
 * @extends phina.display.DisplayElement
 */
phina.define("phina.display.BaseStackLayout", {
    superClass: "phina.display.FlexibleElement",
    init: function(param){
        param=(param||{}).$safe(phina.display.BaseStackLayout.defaults);
        param.$extend(phina.display.BaseStackLayout.fix);
        this.superInit(param);
        this.setOrigin(0,0);
        this.on('resize', function(){
            this.relocation();
        });
    },
    /** @override */
    addChild: function(child, dir){
        this.superMethod('addChild', child);
        var childOrigin = child.baseOrigin? child.baseOrigin :(child.baseOrigin = child.origin.clone());

        child.renderChildBySelf = true;
        child.setOrigin(0,0);
        child.globalToLocal = function(p){
            var matrix = this._worldMatrix.clone();
            var w = this.width;
            var h = this.height;
            if(this.canvas){
                w = this.canvas.domElement.width;
                h = this.canvas.domElement.height;
            }
            matrix.m02 -= w*(0.5-this.origin.x);
            matrix.m12 -= h*(0.5-this.origin.y);
            matrix.invert();
            // matrix.transpose();
        
            var temp = matrix.multiplyVector2(p);
        
            return temp;
        };
        child.draw = function(canvas) {
            var w = this.width;
            var h = this.height;
            if(this.canvas){
                var image = this.canvas.domElement;
                w = image.width;
                h = image.height;
            
                var x = -this.width*this.origin.x;
                var y = -this.height*this.origin.y;
            
                canvas.context.drawImage(image,
                    0, 0, w, h,
                    x, y, w, h
                    );
            }else if(this.image){ //TODO ちゃんと判定した方がいいかもしれない
                var image = this.image.domElement;
                var srcRect = this.srcRect;
                canvas.context.drawImage(image,
                    srcRect.x, srcRect.y, srcRect.width, srcRect.height,
                    -this._width*this.originX, -this._height*this.originY, this._width, this._height
                    );
            }
            var local = this._worldMatrix;
            local.m02 += w*(childOrigin.x);
            local.m12 += h*(childOrigin.y);
        
            //子供たちも実行
            if (this.children.length > 0) {
                var tempChildren = this.children.slice();
                for (var i=0,len=tempChildren.length; i<len; ++i) {
                    this.getRoot().renderer.renderObject(tempChildren[i]);
                }
            }
        };

        this.relocation();
        return child;
    },
    relocation: function(){

    },
    _static:{
        defaults:{
            width: 1, height: 1,
        },
        fix:{
            padding: 0,
        },
    }
});


/**
 * @class phina.display.Counter
 * @extends phina.display.Shape
 */
phina.define("phina.display.Counter", {
    superClass: "phina.display.Shape",
    init: function(param){
        param = (param||{}).$safe(phina.display.Counter.defaults);
        var self = this;
        this.superInit(param);
        this._value = param.value;
        var k=!param.value*1 || Math.floor(Math.LOG10E*Math.log(param.value))+1 || 1;
        var n=param.value;
        this.gridX = Grid({
            width: param.digitWidth*k,
            //width: param.digitFont.width*k,
            columns: k,
        });
        for(var i=0;i<k;i++){
            //var d = {}.$extend(param.digitFont);
            var d = phina.display.CounterDigit({
                image: param.digitFont,
                width: param.digitWidth,
                height: param.digitHeight
            });
            d.setFrameIndex(n%10);
            d.setPosition(this.gridX.span(k-i-1), 0);
            n=Math.floor(n/10);
            d.addChildTo(this);
        }
        this.tweener
        .by({y:80},1000,"easeOutBounce")
        .wait(500)
        .call(function(){ this.remove(); }.bind(this));
    },
    _static: {
        defaults:{
            value: 0,
            // digitFont: phina.display.CounterDigit,
            fill: 'transparent',
            stroke: 'transparent',
            backgroundColor: 'transparent',
        }
    }
});


/**
 * @class phina.display.CounterDigit
 * @extends phina.display.Sprite
 */
phina.define("phina.display.CounterDigit", {
    superClass: "phina.display.Sprite",
    init: function(param){
        param = (param||{}).$safe(phina.display.CounterDigit.defaults);
        this.superInit(param.image, param.width, param.height);
    },
    _static: {
        defaults:{
            image: "noimage",
            width: 20,
            height: 30,
            value: 0,
        },
    }
});


/**
 * @class phina.display.FlexibleElement
 * FlexibleElement
 * @extends phina.display.PlainElement
 */
phina.define("phina.display.FlexibleElement", {
  superClass: "phina.display.PlainElement",
  init: function(param){
    var self = this;
    param=(param||{}).$safe(phina.display.FlexibleElement.defaults);
    this.superInit(param);
    this.__minWidth = param.minWidth;
    this.__minHeight = param.minHeight;
  },
  /** @override */
  addChild: function(child) {
    this.superMethod('addChild', child);

    if(!child.ignoreAutoResize){
      // child.position.$watch('x', this.autoResize.bind(this));
      // child.position.$watch('y', this.autoResize.bind(this));
      child.scale.$watch('x', this.autoResize.bind(this));
      child.scale.$watch('y', this.autoResize.bind(this));
      child.origin.$watch('x', this.autoResize.bind(this));
      child.origin.$watch('y', this.autoResize.bind(this));
      child.$watch('width', this.autoResize.bind(this));
      child.$watch('height', this.autoResize.bind(this));
      this.autoResize();
    }

    return child;
  },
  autoResize: function(){
    this.flare('resize');
    var l=0,r=0,t=0,b=0;
    this.children.map(function(val){
      if(val.ignoreAutoResize){ return; }
      l = l.min(val.left);
      r = r.max(val.right);
      t = t.min(val.top);
      b = b.max(val.bottom);
    });
    var _l = l.min(-r*this.originX*2),
      _r = r.max(-l*(2-this.originX*2).clamp(0,1)),
      _t = t.min(-b*this.originY*2),
      _b = b.max(-t*(2-this.originY*2).clamp(0,1));
    this.width = this.minWidth.max(_r-_l);
    this.height =this.minHeight.max(_b-_t);
    this.canvas.setSize(this.width, this.height);
    this.flare('resized');
  },
  _static: {
    defaults: {
      minWidth:1, minHeight:1,
    }
  },
  _accessor: {
    minWidth:{
      set:function(v){
        this.__minWidth = v;
        this.autoResize();
      },
      get:function(){ return this.__minWidth; }
    },
    minHeight: {
      set:function(v){
        this.__minHeight = v;
        this.autoResize();
      },
      get:function(){ return this.__minHeight; }
    }
  }
});


/**
 * @class phina.display.Fukidashi
 * @extends phina.display.DisplayElement
 */
phina.define("phina.display.Fukidashi", {
    superClass: "phina.display.DisplayElement",
    init: function(options){
      options = (options||{}).$safe(phina.display.Fukidashi.defaults);
      this.superInit(options);
      var self = this;
      this.canvas = phina.graphics.Canvas();
      this.width = this.calcTextWidth(options);
      this.width = this.width>options.width?options.width:this.width;
      this.text = phina.display.LabelArea({
        width:this.width, height:30, autoHeight:true,
        align:"center", fill:'#000',
        text: options.text, fontFamily: options.fontFamily,
        fontSize:options.fontSize, fontWeight:options.fontWeight,
      });
      this.back = phina.display._Fukidashi({
        fill:options.stroke, stroke:options.stroke,
        width:this.width+options.padding, height:this.text.height+options.padding,
        strokeWidth:options.strokeWidth, arrowRadian:options.arrowRadian,
      }).addChildTo(this).setPosition(0,0);
      this.front = phina.display._Fukidashi({
        fill:options.fill, stroke:'transparent', front:true,
        width:this.width+options.padding, height:this.text.height+options.padding,
        strokeWidth:options.strokeWidth, arrowRadian:options.arrowRadian,
      }).addChildTo(this).setPosition(0,0);
      this.text.addChildTo(this).setPosition(0,0);
      this.arrowRadian = options.arrowRadian;
    },
    calcTextWidth: function(options){
      var width;
      var maxWidth = options.width;
      var context = this.canvas.context;
      context.font = "{fontWeight} {fontSize}px {fontFamily}".format(options);
      width = context.measureText(options.text).width;
      return width;
    },
    _static: {
      defaults: {
        fontSize:32,
        fontWeight:'',
        fontFamily: "'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif",
        backgroundColor: 'transparent',
        fill: 'blue',
        stroke: '#aaa',
        padding: 20,
        strokeWidth: 4,
        arrowRadian: 45,
        text: "テストだ！",
      },
    },
  });
  phina.define("phina.display._Fukidashi", {
    superClass: "phina.display.Shape",
    init: function(options){
      options = (options||{}).$safe(phina.display._Fukidashi.defaults);
      this.superInit(options);
      var self = this;
      this.arrow = phina.display.Shape(options).fromJSON({
        prerender: function(canvas){
          var l = -self.width/2,
              r = self.width/2,
              t = -self.height/2,
              b = self.height/2,
              rn = Math.sqrt(Math.pow(self.width/2,2)+Math.pow(self.height/2,2)),
              px = rn * Math.cos(options.arrowRadian),
              py = rn * Math.sin(options.arrowRadian);
            canvas.context.moveTo(0, t+self.height/4);
            canvas.context.lineTo(px, py);
            canvas.context.lineTo(0, b-self.height/4);
            canvas.closePath();
        }
      }).addChildTo(this).setPosition(0,0);
      this.arrowSize = options.arrowSize;
      this.zure = options.front ? 3:0;
    },
    prerender: function(canvas) {
      this.roundFukidashi(canvas, -this.width/2, -this.height/2, this.width, this.height, this.zure);
    },
    roundFukidashi: function(canvas, x, y, width, height, zure){
      var l = x,
          r = x + width,
          t = y,
          b = y + height,
          l1=l, l2=l+width/4, l3=l+width/50,
          r1=r, r2=r-width/4, r3=r-width/50,
          t1=t, t2=t+height/4, t3=t+height/6,
          b1=b, b2=b-height/4, b3=b-height/6;
      canvas.context.lineTo(l1, t2);            //左真ん中
      canvas.context.lineTo(l2, t1+zure);       //左上
      canvas.context.lineTo(r3-zure, t3);       //右上
      canvas.context.lineTo(r1, b2);            //右真ん中
      canvas.context.lineTo(r2, b1-zure);       //右下
      canvas.context.lineTo(l3+zure, b3);       //左下
      canvas.closePath();
    },
    _static: {
      defaults: {
        backgroundColor: 'transparent',
        fill: 'blue',
        stroke: '#aaa',
        strokeWidth: 4,
        arrowRadian: 45,
      },
    },
  });
  

/**
 * @class phina.display.HorizonStackLayout
 * @extends phina.display.BaseStackLayout
 */
phina.define("phina.display.HorizonStackLayout", {
    superClass: "phina.display.BaseStackLayout",
    init: function(param){
        param=(param||{}).$safe(phina.display.HorizonStackLayout.defaults);
        param.$extend(phina.display.HorizonStackLayout.fix);
        this.superInit(param);
    },
    /** @override */
    addChild: function(child, dir){
        this.superMethod('addChild', child, dir);
    },
    /** @override */
    relocation: function(){
        var layout_map = [];
        this.children.forEach(function(child){
            if(child.name && child.name.lastIndexOf("__",0)===0){
                return;//do nothing
            }else{
                layout_map.push(child);
            }
        });
        if(layout_map.length==0){return;}
        var base_x = 0;
        layout_map.forEach(function(child, y){
            var padding = child.lpadding||0;
            var paddingHorizontal = child.lpaddingHorizon||padding||0;
            var paddingVertical = child.lpaddingVertical||padding||0;
            var paddingTop = child.lpaddingTop||paddingVertical||0;
            var paddingBottom = child.lpaddingBottom||paddingVertical||0;
            var paddingLeft = child.lpaddingLeft||paddingHorizontal||0;
            var paddingRight = child.lpaddingRight||paddingHorizontal||0;
            base_x += paddingLeft;
            child.x = base_x;
            child.y = paddingTop;
            base_x += child.width+paddingRight;
        }.bind(this));
    },
    _static:{
        defaults:{
        },
        fix:{
        },
    }
});


/**
 * @class phina.diplay.LabelArea
 * @extends phina.ui.LabelArea
 */
phina.define("phina.display.LabelArea", {
  superClass: "phina.ui.LabelArea",
  init: function(param){
    param = (param||{}).$safe(phina.display.LabelArea.defaults);
    this.superInit(param);
    if(param.autoHeight){
        var height = this.height.max(
                this.getLines().length*this.fontSize*this.lineHeight);
        this.height = height;
    }
  },
  _static: {
      defaults: {
          fontFamily: "'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif",
          stroke: false,
          fill: "white",
          autoHeight: false,
      }
  }
});


phina.define('phina.display.LabelArea2', {
  superClass: 'phina.display.DisplayElement',
  init: function(param) {
    param=(param||{}).$safe(phina.display.LabelArea2.default)
    this.superInit(param)

    this.label = phina.display.LabelArea(param)
    .addChildTo(this)

    this.on('changed', this.showText.bind(this))
  },
  showText: function(){
    let appendText = ''
    if(this.text.startsWith(this.label.text)){
      appendText = this.text.substr(this.label.text.length)
    }else{
      this.label.text = ''
      appendText = this.text
    }
    this.tweener.clear()
    let text = ''
    let scroll = 0
    appendText.each((c, i)=>{
      if(i%3==2){
        this.tweener.wait(100)
      }
      text += c
      var lines = this.spliceLines((text + '').split('\n'))
      if(this.label.lineSize * lines.length - scroll > this.label.height){
        //scrollは逆方向なので行数-1
        let _scroll = scroll = this.label.lineSize * (lines.length-1)
        this.tweener
          .wait(4000)
          .call(()=>{
            console.log(_scroll)
            this.label.tweener
              .clear()
              .to({ scrollY: _scroll },750,'easeOutCubic')
          })
          .call(()=>{
            this.label.text += c
          })
      }else{
        this.tweener
          .call(()=>{
            this.label.text += c
          })
      }
    })
    this.tweener
      .call(()=>{ this.flare('showed') })
  },
  spliceLines: function(lines) {
    var rowWidth = this.label.width;
    var context = this.label.canvas.context;
    context.font = this.label.font;

    var cache = this.label.getTextWidthCache();
    
    var localLines = [];
    lines.forEach(function(line) {
      // update cache
      line.each(function(ch) {
        if (!cache[ch]) {
          cache[ch] = context.measureText(ch).width;
        }
      });
      
      var str = '';
      var totalWidth = 0;

      // はみ出ていたら強制的に改行する
      line.each(function(ch) {
        var w = cache[ch];

        if ((totalWidth+w) > rowWidth) {
          localLines.push(str);
          str = '';
          totalWidth = 0;
        }

        str += ch;
        totalWidth += w;
      });

      // 残りを push する
      localLines.push(str);

    });
    

    return localLines;
  },
_accessor: {
    visibleText: {
      get: function(){ return this.label.text }
    },
    text:{
      get: function(){ return this._body },
      set: function(v){
        this._body = v 
        this.label.scrollY = 0
        this.flare('changed')
      }
    }
  },
  _static: {
    default: {
      animation: true
    }
  }
})


/**
 * @class phina.display.StackLayout
 * @extends phina.display.VerticalStackLayout
 */
phina.define("phina.display.StackLayout", {
    superClass: "phina.display.VerticalStackLayout",
    init: function(param){
        param=(param||{}).$safe(phina.display.StackLayout.defaults);
        param.$extend(phina.display.StackLayout.fix);
        this.superInit(param);
        this.br(param.height);
    },
    /** @override */
    addChild: function(child, dir){
        if(dir){
            return this.superMethod('addChild', child, dir);
        }else{
            this.children.last.addChild(child);
            this.relocation();
            return child;
        }
    },
    br: function(height){
        this
        .addChild(phina.display.HorizonStackLayout({
            fill: this.fill,
            stroke: this.stroke,
            backgroundColor: this.backgroundColor,
        }),true)
        if(height){
            phina.display.DisplayElement({
                width:0, height:height, padding:0,
            }).addChildTo(this);
        }
        return this;
    },
    _static:{
        defaults:{
        },
        fix:{
        },
    }
});


/**
 * @class phina.display.VerticalStackLayout
 * @extends phina.display.BaseStackLayout
 */
phina.define("phina.display.VerticalStackLayout", {
    superClass: "phina.display.BaseStackLayout",
    init: function(param){
        param=(param||{}).$safe(phina.display.VerticalStackLayout.defaults);
        param.$extend(phina.display.VerticalStackLayout.fix);
        this.superInit(param);
    },
    /** @override */
    addChild: function(child, dir){
        this.superMethod('addChild', child, dir);
    },
    /** @override */
    relocation: function(){
        var layout_map = [];
        this.children.forEach(function(child){
            if(child.name && child.name.lastIndexOf("__",0)===0){
                return;//do nothing
            }else{
                layout_map.push(child);
            }
        });
        if(layout_map.length==0){return;}
        var base_y = 0;
        layout_map.forEach(function(child, y){
            var padding = child.lpadding||0;
            var paddingHorizontal = child.lpaddingHorizon||padding||0;
            var paddingVertical = child.lpaddingVertical||padding||0;
            var paddingTop = child.lpaddingTop||paddingVertical||0;
            var paddingBottom = child.lpaddingBottom||paddingVertical||0;
            var paddingLeft = child.lpaddingLeft||paddingHorizontal||0;
            var paddingRight = child.lpaddingRight||paddingHorizontal||0;
            base_y += paddingTop;
            child.y = base_y;
            child.x = paddingLeft;
            base_y += child.height+paddingBottom;
        }.bind(this));
    },
    _static:{
        defaults:{
        },
        fix:{
        },
    }
});


phina.namespace(function(){
  phina.app.Element.prototype.traceParent = function(callback){
    if(this.parent){
      callback.call(this, this.parent);
      this.parent.traceParent(callback);
    }
  };
  phina.app.Element.prototype.traceChild = function(callback){
    this.children.map(function(child){
      callback.call(this, child);
      child.traceChild(callback);
    })
  };
  phina.app.Element.prototype.watchParent = function(callback, param){
    this._watchParent(callback, param);
  };
  phina.app.Element.prototype._watchParent = function(callback){
    if(callback.apply(this)){
    }else if(this.parent){
      if(this.parent.parent){
        this.parent._watchParent(callback);
      }else{
        this.parent.one('added', function(){
          this.parent._watchParent(callback);
        })
      }
    }else{
      this.one('added', function(){
        this._watchParent(callback);
      })
    }
  }
})

/**
 * @class phina.form.Ajax
 * 
 */
phina.define('phina.form.Ajax', {
  _static: {
    defaults: {
      type: 'GET',
      contentType: 'application/x-www-form-urlencoded',
      responseType: 'json',
      data: null,
      url: '',
    },

    request: function(options) {
      var data = ({}).$safe(options, this.defaults);

      var xhr = new XMLHttpRequest();
      var flow = phina.util.Flow(function(resolve, reject) {
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if ([200, 201, 0].indexOf(xhr.status) !== -1) {
              resolve(xhr.response.$extend({responseCode:xhr.status}));
            }else{
              reject(xhr.response.$extend({responseCode:xhr.status}));
            }
          }
        };

        xhr.open(data.type, data.url);
        xhr.setRequestHeader("Content-Type", data.contentType);
        xhr.responseType = data.responseType;
        xhr.send(data.data);
      });
      flow.reject = function(arg){
        flow.flare('rejected', {response:arg});
      };

      return flow;
    },
    get: function(url) {
      return this.request({
        type: 'GET',
        url: url,
      });
    },
    post: function(url) {
      return this.request({
        type: 'POST',
        url: url,
      });
    },
    put: function(url) {
      return this.request({
        type: 'PUT',
        url: url,
      });
    },
    del: function(url) {
      return this.request({
        type: 'DELETE',
        url: url,
      });
    },
  },
});


/**
 * @class phina.form.CheckButton
 * CheckButton
 * @extends phina.display.PlainElement
 */
phina.define("phina.form.CheckButton", {
    superClass: "phina.form.Input",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.CheckButton.defaults);
        this.superInit(param);
        this.setInteractive(true, 'rect');

        self.formElement.type = 'checkbox'
        self.formElement.value = param.value
        self.formElement.checked = !!param.checked

        self.button = phina.display.RectangleShape({
            stroke:param.stroke,
            width:this.width-2, height:this.height-2,
            fill:param.fill,
            strokeWidth:param.strokeWidth,
        }).setPosition(0,0)
        .addChildTo(self)
        self.button.value = phina.display.RectangleShape({
            width:this.width-6, height:this.height-6,
            stroke:param.stroke,
            fill:param.stroke,
            strokeWidth:1,
        }).setPosition(0,0)
        .addChildTo(self.button)
        self.button.value.visible = !!param.checked;

        self.on('click', self.toggle);
    },
    toggle: function(){
        this.formElement.click();
        var list = this.formParent.requestElement[this.name]; //RadioNodeList
        if(this.formElement === list){
          list.phina.syncInput();
        }else{
          for(var i of list){
            i.phina.syncInput();
          }
        }
    },
    syncInput: function(){
        this.button.value.visible = this.checked;
    },
    _static:{
        defaults:{
            width:20,height:20,
            stroke:'#000', fill:'#FFF',
            strokeWidth:2,
            checked: false,
        }
    },
    _accessor:{
        name: {
            get:function(){ return this.formElement.name; }
        },
        value: {
            get:function(){ return this.formElement.value; }
        },
        checked: {
            set:function(val){
                this.formElement.checked
                    = this.button.value.visible
                    = !!val;
            },
            get:function(){ return this.formElement.checked; }
        }
    }
});


/**
 * @class phina.form.Form
 * @extends phina.display.PlainElement
 */
phina.define("phina.form.Form", {
  superClass: "phina.form.HiddenInput",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.Form.defaults);
    this.superInit(param);

    self.requestElement = document.createElement('form');
    if(param.name){
      self.requestElement.name = param.name
    }
    if(param.action){
      self.requestElement.action = param.action
    }
    if(param.method){
      self.requestElement.method = param.method
    }
  },
  entryInput: function(elm){
    this.requestElement.appendChild(elm.formElement);
    elm.formParent = this;
  },
  exitInput: function(elm){
    this.requestElement.removeChild(elm);
    elm.formParent = undefined;
  },
  syncInput: function(){
    if(this.requestElement.hasChildNodes()){
      var children = this.requestElement.childNodes;
      for(var i=0; i<children.length; i++){
        children[i].phina.syncInput();
      }
      this.value = $(this.requestElement).serialize();
    }
  },
  submit: function(){
    this.syncInput();
    this.flare('submit', {
      form: this.requestElement
    });
  },
  reset: function(){
    this.formElement.reset();
    this.flare('reset', {
      form: this.requestElement
    });
    this.traceChild(function(v){
      if(v instanceof phina.form.Input){
        v.flare('reset');
        v.syncInput();
      }
    })
  },
  _static:{
    defaults:{
      width:20,height:20,
    }
  },
  _accessor:{
    name: {
      get:function(){ return this.requestElement.name; },
      set:function(val){ this.requestElement.name = val; }
    },
    action: {
      get:function(){ return this.requestElement.action; },
      set:function(val){ this.requestElement.action = val; }
    },
    method: {
      get:function(){ return this.requestElement.method; },
      set:function(val){ return this.requestElement.method = val; }
    }
  }
});


/**
 * @class phina.form.HiddenInput
 * @extends phina.form.Input
 */
phina.define("phina.form.HiddenInput", {
    superClass: "phina.form.Input",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.HiddenInput.defaults);
        this.superInit(param);

        self.formElement.type = 'hidden'
        self.formElement.value = param.value
    },
    syncInput: function(){
    },
    _static:{
        defaults:{
        }
    },
    _accessor:{
        value:{
            set: function(val){
                this.formElement.value
                    = val;
            },
            get: function(){ return this.formElement.value; }
        }        
    }
});


/**
 * @class phina.form.HiddenJSONInput
 * @extends phina.form.Input
 */
phina.define("phina.form.HiddenJSONInput", {
    superClass: "phina.form.Input",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.HiddenJSONInput.defaults);
        this.superInit(param);

        self.formElement.type = 'hidden'
        self.value = param.value
    },
    syncInput: function(){
    },
    _static:{
        defaults:{
        }
    },
    _accessor:{
        value:{
            set: function(val){
                this.formElement.value
                    = JSON.stringify(val);
                this.__value = val;
            },
            get: function(){ return this.__value; }
        }        
    }
});


/**
 * @class phina.form.HorizonThreadWindow
 * @extends phina.form.Window
 */
phina.define("phina.form.HorizonThreadWindow", {
  superClass: "phina.form.Window",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.HorizonThreadWindow.defaults);
    this.superInit(param);

    this.nowThread = 0;

    this.childThread = phina.display.HorizonStackLayout({
    }).setPosition(-this.width/2, -this.height/2)
    .addChildTo(this)

  },
  addThread: function(child) {
    child.thread = this;
    this.childThread.addChild(child);
    child.has('addedToThread') && child.flare('addedToThread');
    this.autoSlideThread(this.childThread.children.length-1);
    return this;
  },
  removeThread: function(child) {
    var index = this.childThread.children.indexOf(child);
    if(index>-1){
      var last = this.childThread.children.last;
      while(last != child){
        this.childThread.removeChild(last);
        last = this.childThread.children.last;
      }
      this.childThread.removeChild(child);
      this.childThread.relocation();
      this.autoSlideThread(this.nowThread.clamp(0,this.childThread.children.length-1));
    }
    return this;
  },
  replaceThread: function(child, i){
    var th = this.childThread;
    if(th.children.length > i){
      this.removeThread(th.children[i]);
      this.addThread(child);
    }else{
      this.addThread(child);
    }
  },
  replaceChildThread: function(child, thread, _i){
    var self = this;
    var _child = this;
    if(child.parent === self.childThread){
      _child = child;
    }else{
      child.traceParent(function(parent){
        if(parent.parent === self.childThread){
          _child = parent;
        }
      });
    }
    var i = self.childThread.children.findIndex(function(elm){
      return elm === _child;
    });
    this.replaceThread(thread, i + (_i||0) + 1);
  },
  slideLeftThread: function(){
    while(!this.autoSlideThread(this.nowThread-1));
  },
  slideRightThread: function(){
    while(!this.autoSlideThread(this.nowThread+1));
  },
  slideThread: function(num){
    this.nowThread = num.clamp(0,this.childThread.children.length-1);
    var move = this.childThread.children[this.nowThread].x;
    this.childThread.tweener
      .clear()
      .moveTo(-move-this.width/2,this.childThread.y,500,'easeOutCubic');
  },
  autoSlideThread: function(_num){
    var num = _num.clamp(0,this.childThread.children.length-1);
    if(num != _num){ return true; }
    var child = this.childThread.children[num];
    this.nowThread = num;
    if(child.right + this.childThread.x + this.width/2 > this.width){ // left
      this.childThread.tweener
        .clear()
        .moveTo(-(child.x+child.width-this.width)-this.width/2,
          this.childThread.y,500,'easeOutCubic');
      return true;
    }else if(child.left + this.childThread.x + this.width/2  < 0){ // right
      this.childThread.tweener
        .clear()
        .moveTo(-child.x-this.width/2,
          this.childThread.y,500,'easeOutCubic');
      return true;
    }else{
      return false;
    }
  },
  _static: {
    defaults: {
      leftButton: null, rightButton: null,
      stroke:'transparent', fill:'transparent'
    }
  }
});


/**
 * @class phina.form.HttpRequestScene
 * @extends phina.display.DisplayScene
 */
phina.define("phina.form.HttpRequestScene", {
    superClass: "phina.display.DisplayScene",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.HttpRequestScene.defaults);
        this.superInit(param);

        var session = {
          scene: self,
          app: undefined,
          method: param.method,
          url: param.url,
          assets: param.assets,
          response: undefined,
          contentType: param.contentType,
          success: param.success,
          error: param.error,
          form: param.form,
          data: param.data
        };

        this.on('enter', function(){
          session.app = self.app;
          phina.util.Flow.resolve(session)
            .then(self.before)
            .then(self.submit)
            .then(self.loadSceneAsset)
            .then(self.loadAsset)
            .then(self.after);
        });
    },
    before: function(session){
      return session;
    },
    submit: function(session){
      if((session.url && session.url !== '')||(session.form)){
        var param;
        if(session.form){
          var data = $(session.form.requestElement).serialize();
          param = {
            url:session.url||session.form.action,
            type:session.method||session.form.method||'GET',
            data:data,
          };
        }else{
          param = {
            url:session.url,
            type:session.method||'GET',
            contentType:session.contentType,
            data:session.data,
          };
        }
        return phina.form.Ajax.request(param)
        .on('rejected', (e)=>{
          session.scene.app.popScene();
          session.error(e.response);
        })
        .then(function(response){
          console.log('submited', session);
          session.response = response;
          return phina.util.Flow.resolve(session);
        })
      }else{
        return session;
      }
    },
    loadSceneAsset: function(session){ 
      if(session.assets
        && Object.keys(session.assets).length > 0){
        return phina.asset.AssetLoader()
          .load(session.assets)
          .then(function(){
            return phina.util.Flow.resolve(session);
          });
      }else{
        return session;
      }
    },
    loadAsset: function(session){
      if(session.response
        && session.response.assets
        && Object.keys(session.response.assets).length > 0){
        return phina.asset.AssetLoader()
          .load(session.response.assets)
          .then(function(){
            return phina.util.Flow.resolve(session);
          })
      }else{
        return session;
      }
    },
    after: function(session){
      var self = session.scene;
      var app = self.app;
      app.popScene();
      session.success(session.response);
    },
    _static:{
        defaults:{
          success: function(){ },
          error: function(){ },
          assets: {},
          form: undefined,
          method: undefined,
          url: '',
          data: undefined,
        }
    }
});


/**
 * @class phina.form.Input
 * @extends phina.display.DisplayElement
 */
phina.define("phina.form.Input", {
  superClass: "phina.display.DisplayElement",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.Input.defaults);
    this.superInit(param);

    self.formElement = document.createElement('input');
    self.formElement.name = param.name
    self.formElement.phina = self

    this.on('added', this.searchForm);
    this.on('removed', function(){
      this.formParent.exitInput(this);
    })
  },
  searchForm: function(){
    var self = this;
    self.watchParent(function(){
      if(this.parent instanceof phina.form.Form){
        this.parent.entryInput(self);
        return true;
      }
    })
  },
  syncInput: function(){
  },
  _static:{
    defaults:{
    }
  },
  _accessor:{
    name: {
      get:function(){ return this.formElement.name; }
    }
  }
});


/**
 * @class phina.form.ModalPasswordDialog
 * @extends phina.display.DisplayScene
 */
phina.define("phina.form.ModalPasswordDialog", {
    superClass: "phina.display.DisplayScene",
    init: function(param){
        var self = this;
        this.superInit();
        param=(param||{}).$safe(phina.form.ModalPasswordDialog.defaults);
        self.value = undefined;
        self.inputDialog = $(`
<span id='input_dialog'>
  <input type='password' id='input_val' value='${param.value}'>
</span>
        `).SimpleDialog({
            modal: true,
            resizable: false,
            width: 'auto',
            position: {my:"center",at:phina.isMobile()?"top":"center",of:app.window},
            close: function(event, ui){
                $(this).SimpleDialog('destroy');
                $(this).remove();
                self.app.popScene();
                app.currentScene.traceChild(function(v){
                    v._touchFlags = {}; // pointstay判定を無理やり消す
                })
                if(typeof self.value !== 'undefined'){
                    self.flare("change",{
                        value: self.value,
                        opr: "ok",
                    });
                }else{
                    // self.flare("change",{
                    //     opr: "cancel",
                    // });
                }
            },
        }).SimpleDialog("open");

        self.on('keydown', function(e){
            if(e.keyCode === phina.input.Keyboard.KEY_CODE['enter']){
                self.value = $('#input_val').val();
                $(self.inputDialog).SimpleDialog('close');
            }
        });
    },
    _static:{
        defaults:{
            value: '',
        }
    }
});


/**
 * @class phina.form.ModalTextAreaDialog
 * @extends march.scene.IOScene
 */
phina.define("phina.form.ModalTextAreaDialog", {
    superClass: "phina.display.DisplayScene",
    init: function(param){
        var self = this;
        this.superInit();
        param=(param||{}).$safe(phina.form.ModalTextAreaDialog.defaults);
        this.oninputdialog = param.oninputdialog;
        self.value = undefined;
        self.inputDialog = $(`
<span id='input_dialog'>
  <textarea id='input_val'>${param.value}</textarea>
</span>
        `).SimpleDialog({
            // modal: true, //TODO 他はmodalなのに？
            resizable: false,
            width: 'auto',
            position: {my:"center",at:phina.isMobile()?"top":"center",of:app.window},
            close: function(event, ui){
                $(this).SimpleDialog('destroy');
                $(this).remove();
                self.app.popScene();
                app.currentScene.traceChild(function(v){
                    v._touchFlags = {}; // pointstay判定を無理やり消す
                })
                if(typeof self.value !== 'undefined'){
                    self.flare("change",{
                        value: self.value,
                        opr: "ok",
                    });
                }else{
                    // self.flare("change",{
                    //     opr: "cancel",
                    // });
                }
            },
        }).SimpleDialog("open");

        self.on('keydown', function(e){
            self.value = $('#input_val').val();
            // if(e.keyCode === phina.input.Keyboard.KEY_CODE['enter']
            // && self.app.keyboard.getKey('shift')){
            //     $(self.inputDialog).SimpleDialog('close');
            // }
        });
        self.on('click', function(e){
            self.value = $('#input_val').val();
            $(self.inputDialog).SimpleDialog('close');
        })
    },
    _static:{
        defaults:{
            okLabel: "OK",
            cancelLabel: "Cancel",
            value: '',
        }
    }
});


// $.widget('custom.SimpleDialog', $.ui.dialog, {
//     _createTitlebar: function(){ }, //do nothing
// 	_createButtonPane: function() {
// 		this.uiDialogButtonPane = $( "<span>" );
// 		this.uiButtonSet = $( "<span>" )
// 			.appendTo( this.uiDialogButtonPane );
// 		this._createButtons();
// 	},    
// });

/**
 * @class phina.form.ModalTextDialog
 * @extends march.scene.IOScene
 */
phina.define("phina.form.ModalTextDialog", {
    superClass: "phina.display.DisplayScene",
    init: function(param){
        var self = this;
        this.superInit();
        param=(param||{}).$safe(phina.form.ModalTextDialog.defaults);
        this.oninputdialog = param.oninputdialog;
        self.value = undefined;
        self.inputDialog = $(`
<span id='input_dialog'>
  <input id='input_val' value='${param.value}'>
</span>
        `).SimpleDialog({
            modal: true,
            resizable: false,
            width: 'auto',
            position: {my:"center",at:phina.isMobile()?"top":"center",of:app.window},
            close: function(event, ui){
                $(this).SimpleDialog('destroy');
                $(this).remove();
                var app = self.app;
                self.app.popScene();
                app.currentScene.traceChild(function(v){
                    v._touchFlags = {}; // pointstay判定を無理やり消す
                })
                if(typeof self.value !== 'undefined'){
                    self.flare("change",{
                        value: self.value,
                        opr: "ok",
                    });
                }else{
                    // self.flare("change",{
                    //     opr: "cancel",
                    // });
                }
            },
        }).SimpleDialog("open");

        self.on('keydown', function(e){
            if(e.keyCode === phina.input.Keyboard.KEY_CODE['enter']){
                self.value = $('#input_val').val();
                $(self.inputDialog).SimpleDialog('close');
            }
        });
    },
    _static:{
        defaults:{
            okLabel: "OK",
            cancelLabel: "Cancel",
            value: '',
        }
    }
});


/**
 * @class phina.form.VerticalNavigationTab
 * @extends phina.display.FlexibleElement
 */
phina.define("phina.form.VerticalNavigationTab", {
  superClass: "phina.display.FlexibleElement",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.VerticalNavigationTab.defaults);
    this.superInit(param);

    this.layout = phina.display.VerticalStackLayout({
    }).setPosition(0,0)
    .addChildTo(this);

    this.active = null;
    this.on('resize', function(){
      self.layout.setPosition(-self.layout.width/2,-self.layout.height/2);
    })
  },
  addTab: function(tab, focus){
    var self = this;
    tab.addChildTo(this.layout)
    .on('click', function(){
      self.active = tab;
    })
    if(focus){
      this.active = tab;
    }else{
      tab.blur();
    }
    return this;
  },
  _static:{
    defaults:{
      width:20,height:100,
    }
  },
  _accessor:{
    active: {
      set: function(v){
        if(this._active){ this._active.blur(); }
        this._active = v;
        if(this._active){ this._active.focus(); }
      },
      get: function(){ return this._active; }
    }
  }
});
phina.define("phina.form.Tab", {
  superClass: "phina.display.PlainElement",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.Tab.defaults);
    this.superInit(param);
    this.blur();
  },
  focus: function(){
  },
  blur: function(){
  },
  _static:{
    defaults:{
      width:20,height:100,
    }
  },
});
phina.define("phina.form.SimpleTab", {
  superClass: "phina.display.PlainElement",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.SimpleTab.defaults);
    this.superInit(param);
    this.setInteractive(true, 'rect');
    this.stroke = param.stroke;
    this.fill = param.fill;
    this.strokeWidth = param.strokeWidth;

    var label = phina.display.Label({
      width:param.width, height:param.height,
      text:param.text, fontSize:param.fontSize,
      stroke:'transparent', fill:param.fontColor,
    }).setPosition(0,0)
    .addChildTo(this);
  },
  focus: function(){
    this.bg && this.bg.remove();
    this.bg = phina.display.PathShape({
      stroke:this.stroke, strokeWidth:this.strokeWidth,
      paths:[Vector2(this.width/2,-this.height/2),
        Vector2(-this.width/2,-this.height/2),
        Vector2(-this.width/2,this.height/2),
        Vector2(this.width/2,this.height/2)]
    }).setPosition(0,0)
    .addChildTo(this);
  },
  blur: function(){
    this.bg && this.bg.remove();
    this.bg = phina.display.PathShape({
      stroke:this.stroke, strokeWidth:this.strokeWidth,
      paths:[Vector2(this.width/2,-this.height/2),
        Vector2(this.width/2,this.height/2)]
    }).setPosition(0,0)
    .addChildTo(this);
  },
  _static:{
    defaults:{
      width:20,height:100,
      fontColor:'#000',fontSize:14,
      stroke:'#000',fill:'transparent',strokeWidth:3,
    }
  },
});



/**
 * @class phina.form.ScrollArea
 * @extends phina.form.Window
 */
phina.define("phina.form.PagenateArea", {
    superClass: "phina.form.Window",

    scrollParents: [],

    init: function(param){
        var self = this;
        param=(param||{}).$safe(phina.form.PagenateArea.defaults);
        this.superInit(param);

        this._addChild = this.addChild;
        this.pageFunc = param.page;
        this.maxPage = param.maxPage;
        self.go(param.current);

        self.pagenation = phina.form.Pagenation({
            width:self.width, height: param.pagenationHeight,
            current:param.current, page:param.maxPage,
            stroke:'#000',fill:'transparent'
        }).setPosition(0,(self.height-param.pagenationHeight)/2)
        .on('dragstart', function(e){
            self.innerWindow.sleep();
            self.scrollParents.map(function(parent){
                parent.flick.disable();
            })
            self.flare('scrollstart');
        })
        .on('dragend', function(){
            self.innerWindow._touchFlags = {};
            self.innerWindow.traceChild(function(v){
                v._touchFlags = {};
            });
            self.innerWindow.wakeUp();
            self.scrollParents.map(function(parent){
                parent.flick.enable();
            })
            self.flare('scrollend');
        })
        .on('changed', function(e){
            self.go(e.value);
        })
        .addChildTo(self)
        this.addChild = this.addChildToInnerWindow;

        this.on('added', function(){
            self.scrollParents = [];
            self.watchParent(function(parent){
                if(this.parent instanceof phina.form.ScrollArea){
                    self.scrollParents.push(this.parent);
                }
            })
        })
    },
    addChildToInnerWindow: function(child) {
        return this.innerWindow.addChild(child);
    },
    go: function(index){
        var self = this;
        if(self.innerWindow){ self.innerWindow.remove(); }
        this.innerWindow = phina.form.Window({
            width: self.width, height: this.height,
            fill:'transparent', stroke:'transparent',
        }).setPosition(0,0)
        self._addChild(this.innerWindow);
        self.pageFunc(self.innerWindow, index);

        self.flick = phina.accessory.Draggable2()
        .attachTo(this.innerWindow)
        .on('dragstart', function(){
            self.scrollParents.map(function(parent){
                parent.flick.disable();
            })
            self.flare('scrollstart');
        })
        .on('dragend', function(){
            self.scrollParents.map(function(parent){
                parent.flick.enable();
            })
            if(index+1 < self.maxPage && self.innerWindow.x < -self.width/4){
                self.innerWindow.tweener
                    .clear()
                    .to({x:-self.width},250,'easeOutCubic')
                    .call(()=>{ self.go(index+1); self.pagenation.next(); });
            }else if(index > 0 && self.innerWindow.x > self.width/4){
                self.innerWindow.tweener
                    .clear()
                    .to({x:self.width},250,'easeOutCubic')
                    .call(()=>{ self.go(index-1); self.pagenation.previous(); });
            }else{
                self.innerWindow.tweener
                    .clear()
                    .to({x:0},250,'easeOutCubic')
            }
            self.flare('scrollend');
        })
        self.flick.vertical = false;
    },
    _static: {
        defaults: {
            width:100, height:100,
            pagenationHeight:30,
            page: function(window){ },
            fill:'transparent', stroke:'transparent',
            scrollBarStroke:'#CCC',
            scrollY: 0,
            current: 0, maxPage: 1,
        }
    },
    _accessor: {
        innerHeight: {
            set: function(val){
                this.innerWindow.height
                    = this.scrollBar.range
                    = val;
                this.innerScrollArea.height = val - this.height;
            },
            get: function(){ return this.innerWindow.height; }
        },
        scrollY: {
            set: function(val){
                this.innerWindow.y = this.innerScrollArea.height/2-val;
            },
            get: function(){ return this.innerScrollArea.height/2-this.innerWindow.y; }
        },
    }
});


phina.define('phina.form.Pagenation', {
  superClass: 'phina.display.PlainElement',
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.Pagenation.defaults);
    this.superInit(param);
    
    this._page = param.page;
    this._current = param.current;
    let barAreaWidth = self.width-self.height*2;
    var jumpflag = false;
    this.counter = null;

    this.bg = phina.display.RectangleShape({
      width:this.width, height:this.height,
      stroke:param.stroke, fill:param.fill,
      padding: 0, strokeWidth: 1,
    }).fromJSON({alpha:0.7}).setPosition(0,0)
    .addChildTo(this)

    this.barArea = phina.display.DisplayElement({
      width:this._barAllowRange, height:this.height,
    }).setPosition(0,0)
    .addChildTo(this)
    this.bar = phina.display.RectangleShape({
      width:this._barLength, height:this.height*0.90,
      stroke:'transparent', fill:param.stroke,
    }).fromJSON({alpha:0.7})
    .addChildTo(this.barArea)
    if(param.page < 1){
      this.barArea.hide();
      this.bar.hide();
    }else{
      this.barArea.show();
      this.bar.show();
    }

    this.previousButton = phina.display.RectangleShape({
      width:param.height, height:param.height,
      fill:'transparent', stroke:'transparent', strokeWidth:1,
    }).setPosition(-this.width/2+this.height/2,0)
    .addChildTo(this)
    .setInteractive(true, 'rect')
    .on('click', ()=>{ jumpflag=true; self.previous(); })
    phina.display.Label({
      text:'▼', fontSize:parseInt(param.height*0.8),
      fill:param.stroke, stroke:'transparent',
      width:param.height, height:param.height,
    }).setPosition(0,0)
    .setRotation(90)
    .addChildTo(self.previousButton)

    this.nextButton = phina.display.RectangleShape({
      width:param.height, height:param.height,
      fill:'transparent', stroke:'transparent', strokeWidth:1,
    }).setPosition(this.width/2-this.height/2,0)
    .addChildTo(this)
    .setInteractive(true, 'rect')
    .on('click', ()=>{ jumpflag=true; self.next(); })
    phina.display.Label({
      text:'▼', fontSize:parseInt(param.height*0.8),
      fill:param.stroke, stroke:'transparent',
      width:param.height, height:param.height,
    }).setPosition(0,0)
    .setRotation(-90)
    .addChildTo(self.nextButton)

    let drag = phina.accessory.Draggable2().attachTo(this.bar);
    drag.vertical = false;
    drag.on('dragstart', function(e){
      jumpflag = true;
      self.flare('dragstart');
      self.popCounter(self.current);
    });
    drag.on('drag', function(){
      let val = Math.floor((self.page)*(barAreaWidth/2+self.bar.x)/barAreaWidth);
      self.flare('drag', { value: val })
      if(self.current!=val){
        self.flare('changing', { value: val });
        self.popCounter(val);
      }
    })
    drag.on('dragend', function(){
      let val = Math.floor((self.page)*(barAreaWidth/2+self.bar.x)/barAreaWidth);
      self.flare('dragend');
      self.current = val;
      self.flare('changed', { value: self.current });
      self.removeCounter();
    })

    this.bg.setInteractive('rect');
    this.bg.on('pointend', function(e){
      if(!jumpflag && e.pointer){
        var ox = self._worldMatrix.m02;
        var px = e.pointer.x;
        self.bar.x = px-ox;
        let val = Math.floor((self.page)*(barAreaWidth/2+self.bar.x)/barAreaWidth);
        self.flare('drag', { value: val })
        if(self.current!=val){
          self.current = val;
          self.flare('changed', { value: val });
        }
        self.popCounter(val, true);
      }
      jumpflag = false;
    });
    this.sync(this.current);
  },
  sync: function(value){
    this.bar.x = (value/(this.page-1)) * this._barAllowRange - this._barAllowRange/2;
  },
  previous: function(){
    if(this.current > 0){
      this.current-=1;
      this.sync(this.current);
      this.flare('changed', { value: this.current });
      this.popCounter(this.current, true);
    }
  },
  next: function(){
    if(this.current<this.page-1){
      this.current+=1;
      this.sync(this.current);
      this.flare('changed', { value: this.current });
      this.popCounter(this.current, true);
    }
  },
  popCounter: function(index, fadeout){
    var self = this;
    this.removeCounter();
    this.counter = phina.display.RectangleShape({
      width:20, height:20,
      stroke:'#000', fill:'#000', cornerRadius:1,
    }).setPosition(0, -this.height)
    .addChildTo(this.bar)
    phina.display.Label({
      text:'{0}'.format(index+1), fontSize:18,
      fill:'#FFF', stroke:'transparent',
      width:20, height:20,
    }).setPosition(0,0)
    .addChildTo(this.counter)
    if(fadeout){
      self.counter.tweener
      .wait(1000)
      .to({alpha:0.0},250)
      .call(function(){ self.counter.remove(); self.counter=null; });
    }
  },
  removeCounter: function(){
    if(this.counter){ this.counter.remove(); }
    this.counter = null;
  },
  _static: {
    defaults: {
      width: 200, height: 30,
      page:1, current:0,
      stroke:'#FFF', fill:'transparent'
    }
  },
  _accessor: {
    page: {
      set: function(val){
        this._page = val;
        this.barArea.width = this._barAllowRange;
        this.bar.width = this._barLength;
        if(val < 1){
          this.barArea.hide();
          this.bar.hide();
        }else{
          this.barArea.show();
          this.bar.show();
        }
        this.sync(this.current);
      },
      get: function(){ return this._page; }
    },
    current: {
      set: function(val){
        this._current = val.clamp(0,this.page-1);
        this.sync(val);
      },
      get: function(){ return this._current; }
    },
    _barLength: {
      get: function(){ return (this.width-this.height*2)/this.page; }
    },
    _barAllowRange: {
      get: function(){ return (this.width-this.height*2)-this._barLength; }
    }
  },
  _defined: function(){
    this.prototype.$watch('width', function(val){
      if(this.bg){
        this.bg.width
          = this.barArea.width
          = this.bar.width 
          = val;
      }
    });
    this.prototype.$watch('height', function(val){
      if(this.bg){
        this.bg.height
          = val;
        this.bar.height = this._barLength;
        this.barArea.height = this._barAllowRange;
      }
    })
  },
});



/**
 * @class phina.form.PasswordBox
 * @extends phina.display.RectangleShape
 */
phina.define("phina.form.PasswordBox", {
    superClass: "phina.form.Input",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.PasswordBox.defaults);
        this.superInit(param);
        self.setInteractive(true, 'rect');
        self.on('click', self.changeValue);

        self.formElement.type = 'password'
        self.formElement.value = param.value

        self.bg = phina.display.RectangleShape({
            width:param.width, height:param.height,
            fill:param.fill, stroke:param.stroke,
            padding:2,
        }).setPosition(0,0)
        .fromJSON({
          clip: function(canvas){
            canvas.beginPath();
            var w = this.calcCanvasWidth();
            var h = this.calcCanvasHeight();
            canvas.roundRect(-w/2,-h/2,w,h,this.cornerRadius);
          }
        })
        .addChildTo(self)
        self.valueLabel = phina.display.Label({ //TODO phina.display.Label2
            align:param.align, baseline:param.baseline,
            width:param.width, height:param.height,
            text:param.value.replace(/./g,'*'), fontSize:param.fontSize||this.height-4,
            fill:param.stroke, 
        }).setPosition(-this.width/2,-this.height/2)
        .addChildTo(self.bg)
    },
    changeValue: function(param){
        var self = this;
        this.getRoot().app.pushScene(phina.form.ModalPasswordDialog({
            okLabel: param.okLabel,
            cancelLabel: param.cancelLabel,
            value: self.value,
        }).on('change', function(e){ 
            self.value = e.value;
            self.flare('change', {value: e.value});
        }));
    },
    syncInput: function(){
        this.valueLabel.text = this.value.replace(/./g,'*');
    },
    _static:{
        defaults:{
            align:'left', baseline:'top',
            width:100, height:20,
            value:'', fontSize:0,
            stroke:'#000', fill:'#FFF',
        }
    },
    _accessor:{
        value:{
            set: function(val){
                this.formElement.value = val;
                this.valueLabel.text = val.replace(/./g,'*');
            },
            get: function(){ return this.formElement.value; }
        }        
    }
});


/**
 * @class march.ui.RadioButton
 * @extends phina.display.RectangleShape
 */
phina.define("phina.form.RadioButton", {
  superClass: "phina.form.Input",
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.RadioButton.defaults);
    this.superInit(param);
    this.setInteractive(true, 'rect');

    self.formElement.type = 'radio'
    self.formElement.value = param.value
    self.formElement.checked = !!param.checked

    self.button = phina.display.CircleShape({
      radius: this.height/2-2,
      stroke:param.stroke,
      fill:param.fill,
      strokeWidth:param.strokeWidth
    }).setPosition(0,0)
    .addChildTo(self)
    self.button.value = phina.display.CircleShape({
      radius: this.height/2-6,
      stroke: param.stroke, fill:param.stroke,
      strokeWidth:1,
    }).setPosition(0,0)
    .addChildTo(self)
    self.button.value.visible = !!param.checked;

    self.on('click', self.toggle);
  },
  toggle: function(){
    this.formElement.click();
    var list = this.formParent.requestElement[this.name]; //RadioNodeList
    if(this.formElement === list){
      list.phina.syncInput();
    }else{
      for(var i of list){
        i.phina.syncInput();
      }
    }
  },
  syncInput: function(){
    this.button.value.visible = this.checked;
  },
  _static:{
    defaults:{
      width:20,height:20,
      stroke:'#000', fill:'#FFF',
      strokeWidth:2,
      checked: false,
    }
  },
  _accessor:{
    name: {
      get:function(){ return this.formElement.name; }
    },
    value: {
      get:function(){ return this.formElement.value; }
    },
    checked: {
      set:function(val){
        this.formElement.checked
          = this.button.value.visible
          = !!val;
      },
      get:function(){ return this.formElement.checked; }
    }
  }
});


/**
 * @class phina.form.ScrollArea
 * @extends phina.form.Window
 */
phina.define("phina.form.ScrollArea", {
    superClass: "phina.form.Window",

    scrollParents: [],

    init: function(param){
        var self = this;
        param=(param||{}).$safe(phina.form.ScrollArea.defaults);
        this.superInit(param);
        let frameHeight = self.height;
        param.innerHeight.max(frameHeight);

        this.innerScrollArea = phina.display.DisplayElement({
            width: self.width, height: param.innerHeight-frameHeight,
        }).setPosition(0,0)
        .addChildTo(self)
        this.innerWindow = phina.form.Window({
            width: self.width, height: param.innerHeight||frameHeight,
            fill:'transparent', stroke:'transparent',
        }).fromJSON({children:param.frame})
        .setPosition(0,0)
        .on('drag', function(e){
            self.scrollBar.sync(self.innerWindow.y);
            self.flare('scroll', { originalEvent: e});
        })
        .on('scroll', function(e){
            self.scrollBar.sync(self.innerWindow.y);
            self.flare('scroll', { originalEvent: e});
        })
        .on('slip', function(e){
            self.scrollBar.sync(self.innerWindow.y);
        })
        .addChildTo(self.innerScrollArea);

        self.flick = phina.accessory.Flickable2()
        .attachTo(this.innerWindow)
        .on('dragstart', function(){
            self.scrollParents.map(function(parent){
                parent.flick.disable();
            })
            self.flare('scrollstart');
        })
        .on('dragend', function(){
            self.scrollParents.map(function(parent){
                parent.flick.enable();
            })
            self.flare('scrollend');
        });
        self.flick.horizontal = false;

        self.mousewheelscroll = phina.accessory.MouseWheelScrollable()
        .attachTo(this.innerWindow)
        .on('scroll', function(e){
            if(!e.overY){
                self.scrollParents.map(function(parent){
                    parent.mousewheelscroll.wait();
                })
            }
        })
        self.mousewheelscroll.horizontal = false;
        self.mousewheelscroll.gain = -36.0;

        this.scrollBar = phina.form.ScrollBar({
            width:param.scrollbarWidth, height: frameHeight,
            length: frameHeight, range: param.innerHeight||frameHeight,
            stroke:param.scrollBarStroke,
        }).setPosition((this.width-param.scrollbarWidth)/2,0)
        .on('drag', function(e){
            self.innerWindow.y = e.value;
            self.flare('scroll', { originalEvent: e});
        })
        .on('dragstart', function(e){
            self.flick.disable();
            self.innerWindow.sleep();
            self.scrollParents.map(function(parent){
                parent.flick.disable();
            })
            self.flare('scrollstart');
        })
        .on('dragend', function(){
            self.flick.enable();
            self.innerWindow._touchFlags = {};
            self.innerWindow.traceChild(function(v){
                v._touchFlags = {};
            });
            self.innerWindow.wakeUp();
            self.scrollParents.map(function(parent){
                parent.flick.enable();
            })
            self.flare('scrollend');
        })
        .addChildTo(self)
        this.addChild = this.addChildToInnerWindow;
        self.scrollY = param.scrollY;

        this.on('added', function(){
            self.scrollParents = [];
            self.watchParent(function(parent){
                if(this.parent instanceof phina.form.ScrollArea){
                    self.scrollParents.push(this.parent);
                }
            })
        })
    },
    addChildToInnerWindow: function(child) {
        return this.innerWindow.addChild(child);
    },
    _static: {
        defaults: {
            width:100, height:100,
            innerHeight:100,
            scrollbarWidth:30,
            frame: {},
            fill:'transparent', stroke:'transparent',
            scrollBarStroke:'#CCC',
            scrollY: 0,
        }
    },
    _accessor: {
        innerHeight: {
            set: function(val){
                this.innerWindow.height
                    = this.scrollBar.range
                    = val;
                this.innerScrollArea.height = val - this.height;
            },
            get: function(){ return this.innerWindow.height; }
        },
        height: {
            set: function(val){
                this._height = val;
                if(this.scrollBar){
                    this.scrollBar.height
                        = this.scrollBar.length
                        = val;
                }
            },
            get: function(){ return this._height; }
        },
        scrollY: {
            set: function(val){
                this.innerWindow.y = this.innerScrollArea.height/2-val;
                this.innerWindow.flare('scroll');
            },
            get: function(){ return this.innerScrollArea.height/2-this.innerWindow.y; }
          },
        }
});


phina.define('phina.form.ScrollBar', {
  superClass: 'phina.display.PlainElement',
  init: function(param){
    var self = this;
    param = (param||{}).$safe(phina.form.ScrollBar.defaults);
    this.superInit(param);
    
    this._length = param.length;
    this._range = param.range;
    var jumpflag = false;

    this.bg = phina.display.RectangleShape({
      width:this.width, height:this.height,
      stroke:param.stroke, fill:param.fill,
      padding: 0, strokeWidth: 1,
    }).fromJSON({alpha:0.7}).setPosition(0,0)
    .addChildTo(this)

    this.barArea = phina.display.DisplayElement({
      width:this.width, height:this._barAllowRange,
    }).setPosition(0,0)
    .addChildTo(this)
    this.bar = phina.display.RectangleShape({
      width:this.width*0.90, height:this._barLength,
      stroke:'transparent', fill:param.stroke,
    }).fromJSON({alpha:0.7})
    .addChildTo(this.barArea)
    
    let drag = phina.accessory.Draggable2().attachTo(this.bar);
    drag.horizontal = false;
    drag.on('dragstart', function(e){
      jumpflag = false;
      self.flare('dragstart');
    });
    drag.on('drag', function(){ self.flare('drag', {
      value: -(self.range-self.length)*(self._barAllowRange/2+self.bar.y)/self._barAllowRange
        +(self.range-self.length)/2
    })})
    drag.on('dragend', function(){
      self.flare('dragend');
    })

    this.setInteractive('rect');
    this.on('pointend', function(e){
      if(jumpflag && e.pointer){
        var oy = self._worldMatrix.m12;
        var py = e.pointer.y;
        self.bar.y = py-oy;
        self.flare('drag', {
          value: -(self.range-self.length)*(self._barAllowRange/2+self.bar.y)/self._barAllowRange
          +(self.range-self.length)/2
        })
      }
      jumpflag = true;
    });
  },
  sync: function(value){
    this.bar.y = -((value+(this.range-this.length)/2)/(this.range-this.length))
      * (this.height-this.bar.height) + (this.height-this.bar.height)/2
  },
  _static: {
    defaults: {
      width: 30, height: 200,
      length:100, range:200,
      stroke:'#FFF', fill:'transparent'
    }
  },
  _accessor: {
    length: {
      set: function(val){
        this._length = val;
        this.bar.height = this._barLength;
        this.barArea.height = this._barAllowRange;
      },
      get: function(){ return this._length; }
    },
    range: {
      set: function(val){
        this._range = val;
        this.bar.height = this._barLength;
        this.barArea.height = this._barAllowRange;
      },
      get: function(){ return this._range; }
    },
    height: {
      set: function(val){
        this._height = val;
        if(this.bar){
          this.bar.height = this._barLength;
          this.barArea.height = this._barAllowRange;
          this.bg.height = this._height;
        }
      },
      get: function(){ return this._height; }
    },
    _barLength: {
      get: function(){ return this.height * (this.length / this.range); }
    },
    _barAllowRange: {
      get: function(){ return this.height - this._barLength; }
    }
  },
  _defined: function(){
    this.prototype.$watch('width', function(val){
      if(this.bg){
        this.bg.width
          = this.barArea.width
          = this.bar.width 
          = val;
      }
    });
    this.prototype.$watch('height', function(val){
      if(this.bg){
        this.bg.height
          = val;
        this.bar.height = this._barLength;
        this.barArea.height = this._barAllowRange;
      }
    })
  },
});



/**
 * @class phina.form.ScrollWindow
 * @extends phina.form.SystemWindow
 */
phina.define("phina.form.ScrollWindow", {
    superClass: "phina.form.SystemWindow",
    init: function(param){
        var self = this;
        param=(param||{}).$safe(phina.form.ScrollWindow.defaults);
        this.superInit(param);
        let frameHeight = self.bodyFrame.height;
        param.innerHeight.max(frameHeight);

        this.innerScrollArea = phina.display.PlainElement({
            width: self.width-30, height: param.innerHeight-frameHeight,
        }).setPosition(-10,0)
        .addChildTo(self)
        this.innerWindow = phina.form.Window({
            width: self.width-30, height: param.innerHeight||frameHeight,
            fill:'transparent', stroke:'transparent',
        }).fromJSON({children:param.frame})
        .setPosition(-10,0)
        .on('drag', function(e){
            self.scrollBar.sync(self.innerWindow.y);
        })
        .on('scroll', function(e){
            self.scrollBar.sync(self.innerWindow.y);
        })
        .on('slip', function(e){
            self.scrollBar.sync(self.innerWindow.y);
        })
        .addChildTo(self.innerScrollArea);
        var flick = phina.accessory.Flickable2().attachTo(this.innerWindow);
        flick.horizontal = false;
        var mousewheelscroll = phina.accessory.MouseWheelScrollable().attachTo(this.innerWindow)
        mousewheelscroll.horizontal = false;

        this.scrollBar = phina.form.ScrollBar({
            width:30, height: frameHeight,
            length: frameHeight, range: param.innerHeight||frameHeight
        }).setPosition(this.width/2-15,0)
        .on('drag', function(e){
            self.innerWindow.y = e.value;
        })
        .on('dragstart', function(e){
            self.flickable.cancel();
        })
        .addChildTo(self)
        this.addChild = this.addChildToInnerWindow;
    },
    addChildToInnerWindow: function(child) {
        return this.innerWindow.addChild(child);
    },
    _static: {
        defaults: {
            frame: {}
        }
    },
});


/**
 * @class phina.form.SelectBox
 * @extends phina.form.Input
 */
phina.define("phina.form.SelectBox", {
  superClass: "phina.form.Input",
  init: function(param){
    var self = this;
    var initValue = param.value;
    param = (param||{}).$safe(phina.form.SelectBox.defaults);
    if(initValue != undefined){ param.value = initValue }
    self.superInit(param);

    self.formElement = document.createElement('select');
    self.formElement.name = param.name;
    self.formElement.phina = self;
    param.selections.map(function(v){
      var opt = document.createElement('option');
      opt.innerText = v.label;
      opt.value = v.value;
      self.formElement.appendChild(opt);
    })
    self.formElement.value = param.value;

    self._selections = param.selections;

    self.bg = phina.display.RectangleShape({
      width:param.width, height:param.height,
      fill:param.fill, stroke:param.stroke
    }).setPosition(0,0)
    .setInteractive(true, 'rect')
    .on('click', self.showSelection.bind(self))
    .addChildTo(self)

    phina.display.Label({
      text:'▼', fontSize:parseInt(param.height*0.8),
      fill:param.stroke, stroke:'transparent',
      width:param.height, height:param.height,
    }).setPosition(self.width/2-self.height/2,0)
    .addChildTo(self)

    self.valueLabel = phina.display.Label({
      text:param.value!=undefined ? param.selections[self.formElement.selectedIndex].label : '',
      fontSize:parseInt(param.height*0.8),
      fill:param.stroke, stroke:'transparent',
      width:self.width-self.height, height:self.height,
      align:'left', baseline:'middle',
    }).setPosition(-self.width/2, 0)
    .addChildTo(self)

    //メニューの定義
    self.selections = phina.form.ScrollArea({
      width:param.width, height:param.height*param.selections.length.min(3),
      innerHeight:param.height*param.selections.length,
      stroke:'#CCC',scrollbarWidth:20,
    })
    .on('scroll', function(e){
      if(e.originalEvent.value){
        self.lock = false;
      }
    })
    .on('scrollend', function(e){
      self.lock = true;
    })
    var table = phina.form.Table({
      width:param.width, height:param.height*param.selections.length,
    }).setPosition(-(param.width)/2,-(param.height*param.selections.length/2))
    .addChildTo(self.selections)
    param.selections.map(function(v){
      table.insert([
        function(td){
          td.setInteractive(true, 'rect')
          .on('click', function(){
            if(self.lock){
              self.value = v.value;
              self.hideSelection();
            }
          })
          var rect = phina.display.RectangleShape({
            width:self.width, height:self.height,
            stroke:'#CCC',fill:'#FFF',strokeWidth:2,padding:0
          }).addChildTo(td)
          phina.display.Label({
            text:v.label,
            fontSize:parseInt(param.height*0.8),
            fill:param.stroke, stroke:'transparent',
            width:self.width, height:self.height,
            align:'left', baseline:'middle', padding:0,
          }).setPosition(-self.width/2,0)
          .addChildTo(rect)
        }
      ]);
    })
  },
  //選択肢の表示
  showSelection: function(){
    var self = this;
    self.lock = true;
    self.selectionScene = phina.display.DisplayScene({
      width:self.getRoot().width, height:self.getRoot().height,
    }).on('click', function(){
      if(self.selectionScene && self.lock){
        self.hideSelection();
      }
    });
    self.selections
    .setPosition(self._worldMatrix.m02,
      self._worldMatrix.m12+self.height*(self._selections.length.min(3)+1)/2)
    .addChildTo(self.selectionScene)
    self.getRoot().app.pushScene(self.selectionScene);
  },
  //選択肢の非表示
  hideSelection: function(){
    if(this.selectionScene){
      this.selectionScene.app.popScene();
      this.selections.innerWindow._touchFlags.forIn(function(k,v){ this[k] = false; });
      this.selectionScene = null;
    }
    this.lock = false;
  },
  _static: {
    defaults: {
      width: 100,                       //横幅
      height: 20,                       //縦幅
      selections: [],                   //選択肢 {label: string, value: any}
      value:undefined,                  //デフォルト値(=selections.value)
      fill: '#FFF',                     //背景
      stroke: '#000',                   //前景
    }
  },
  _accessor: {
    value: {
      set: function(v){
        this.formElement.value
          = v;
        this.valueLabel.text = this.formElement.options[this.formElement.selectedIndex].innerText;
      },
      get: function(){ return this.formElement.value }
    }
  }
});



/**
 * @class phina.form.SelectBox2
 * @extends phina.form.Input
 */
phina.define("phina.form.SelectBox2", {
  superClass: "phina.form.Input",
  init: function(param){
    var self = this;
    var initValue = param.value;
    param = (param||{}).$safe(phina.form.SelectBox2.defaults);
    if(initValue != undefined){ param.value = initValue }
    self.superInit(param);

    self.formElement = document.createElement('select');
    self.formElement.name = param.name;
    self.formElement.phina = self;
    param.selections.map(function(v){
      var opt = document.createElement('option');
      opt.innerText = v.label;
      opt.value = v.value;
      self.formElement.appendChild(opt);
    })
    self.formElement.value = param.value;

    self._selections = param.selections;
    self.selectionWidth = param.selectionWidth;
    self.selectionHeight = param.selectionHeight;

    self.bg = phina.display.RectangleShape({
      width:param.width, height:param.height,
      fill:param.fill, stroke:param.stroke
    }).setPosition(0,0)
    .setInteractive(true, 'rect')
    .on('click', self.showSelection.bind(self))
    .addChildTo(self)

    phina.display.Label({
      text:'▼', fontSize:parseInt(param.height*0.8),
      fill:param.stroke, stroke:'transparent',
      width:param.height, height:param.height,
    }).setPosition(self.width/2-self.height/2,0)
    .addChildTo(self)

    self.valueLabel = phina.display.Label({
      text:param.value!=undefined ? param.selections[self.formElement.selectedIndex].label : '',
      fontSize:parseInt(param.height*0.8),
      fill:param.stroke, stroke:'transparent',
      width:self.width-self.height, height:self.height,
      align:'left', baseline:'middle',
    }).setPosition(-self.width/2, 0)
    .addChildTo(self)

    //メニューの定義
    self.selections = phina.form.ScrollArea({
      width:param.selectionWidth, height:param.selectionHeight,
      innerHeight:param.selectionHeight*param.selections.length,
      stroke:'#CCC',scrollbarWidth:20,
    })
    .on('scroll', function(e){
      if(e.originalEvent.value){
        self.lock = false;
      }
    })
    .on('scrollend', function(e){
      self.lock = true;
    })
    var table = phina.form.Table({
      width:param.selectionWidth, height:param.selectionHeight*param.selections.length,
    }).setPosition(-(param.selectionWidth)/2,-(param.selectionHeight*param.selections.length/2))
    .addChildTo(self.selections)
    param.selections.map(function(v){
      table.insert([
        function(td){
          td.setInteractive(true, 'rect')
          .on('click', function(){
            if(self.lock){
              self.value = v.value;
              self.hideSelection();
            }
          })
          var rect = phina.display.RectangleShape({
            width:param.selectionWidth, height:param.selectionHeight,
            stroke:'#CCC',fill:'#FFF',strokeWidth:2,padding:2
          }).addChildTo(td)
          phina.display.Label({
            text:v.label,
            fontSize:parseInt(param.selectionHeight*0.8),
            fill:param.stroke, stroke:'transparent',
            width:param.selectionWidth, height:param.selectionHeight,
            align:'left', baseline:'middle', padding:0,
          }).setPosition(-param.selectionWidth/2,0)
          .addChildTo(rect)
        }
      ]);
    })
  },
  //選択肢の表示
  showSelection: function(){
    var self = this;
    self.lock = true;
    self.selectionScene = phina.display.DisplayScene({
      width:self.getRoot().width, height:self.getRoot().height,
    }).on('click', function(){
      if(self.selectionScene && self.lock){
        self.hideSelection();
      }
    });
    phina.display.RectangleShape({
      width:self.getRoot().width, height:self.getRoot().height,
      fill:'#000', stroke:'transparent',
    }).fromJSON({alpha:0.7}).setPosition(self.selectionScene.width/2,self.selectionScene.height/2)
    .addChildTo(self.selectionScene);
    self.selections
    .fromJSON({
      height: (self.selectionHeight*self._selections.length).min(self.selectionScene.height),
      innerHeight: self.selectionHeight*self._selections.length,
    })
    .setPosition(self.selectionScene.width/2,self.selectionScene.height/2)
    .addChildTo(self.selectionScene)
    self.getRoot().app.pushScene(self.selectionScene);
  },
  //選択肢の非表示
  hideSelection: function(){
    if(this.selectionScene){
      this.selectionScene.app.popScene();
      this.selections.innerWindow._touchFlags.forIn(function(k,v){ this[k] = false; });
      this.selectionScene = null;
    }
    this.lock = false;
  },
  _static: {
    defaults: {
      width: 100,                       //横幅
      height: 20,                       //縦幅
      selections: [],                   //選択肢 {label: string, value: any}
      value:undefined,                  //デフォルト値(=selections.value)
      fill: '#FFF',                     //背景
      stroke: '#000',                   //前景
      selectionWidth:200,               //選択肢横幅
      selectionHeight:30,               //選択肢縦幅
    }
  },
  _accessor: {
    value: {
      set: function(v){
        this.formElement.value
          = v;
        this.valueLabel.text = this.formElement.options[this.formElement.selectedIndex].innerText;
      },
      get: function(){ return this.formElement.value }
    }
  }
});



/**
 * @class phina.form.SpriteBox
 * @extends phina.form.Input
 */
phina.define("phina.form.SpriteBox", {
    superClass: "phina.form.Input",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.SpriteBox.defaults);
        this.superInit(param);
        self.setInteractive(true, 'rect');
        self.on('click', self.changeValue);
        self.autoLoad = param.autoLoad;

        self.formElement.type = 'text'
        self.formElement.value = param.value

        self.autoLoad && self.setImage(param.value);
    },
    changeValue: function(param){
        var self = this;
        this.getRoot().app.pushScene(phina.form.ModalTextDialog({
            okLabel: param.okLabel,
            cancelLabel: param.cancelLabel,
            value: self.value,
        }).on('change', function(e){
            self.value = e.value;
            self.flare('change', {value: e.value});
        }));
    },
    setImage: function(url){
        var self = this;
        if(phina.asset.AssetManager.get('image', url)){
            if(self.valueSprite === undefined){
                self.valueSprite = phina.display.Sprite(url)
                .setPosition(0,0)
                .setSize(self.width,self.height)
                .addChildTo(self)
            }else{
                self.valueSprite.setImage(url);
            }
            self.valueSprite.setSize(self.width, self.height);
        }else{
            var loader = phina.asset.AssetLoader();
            var assets = {"image":[]}; assets["image"][url]=url;
            loader.load(assets);
            loader.onload = function(){
                if(self.valueSprite === undefined){
                    self.valueSprite = phina.display.Sprite(url)
                    .setPosition(0,0)
                    .setSize(self.width,self.height)
                    .addChildTo(self)
                }else{
                    self.valueSprite.setImage(url);
                }
                self.valueSprite.setSize(self.width, self.height);
            };
        }
    },
    _static:{
        defaults:{
            value: "noimage",
            width: 100,
            height: 100,
            autoLoad: true,
        }
    },
    _accessor:{
        value:{
            set: function(val){
                this.formElement.value
                    = val;
                this.autoLoad && this.setImage(val);
            },
            get: function(){ return this.formElement.value; }
        }
    }
});


/**
 * @class phina.form.SpriteFrame
 * @extends phina.display.PlainElement
 */
phina.define('phina.form.SpriteFrame', {
  superClass:'phina.display.Shape',
  init: function(options){
    options = (options || {}).$safe(phina.form.SpriteFrame.defaults);
    this.superInit(options);

    this.bg = phina.display.DisplayElement()
    .addChildTo(this)
  // line
    var pattern = options.borderPattern;
    var tileWidth = options.tileWidth;
    var tileHeight = options.tileHeight;
    // top line
    var _tLine = options.texture[1]
    ? phina.display.Sprite(options.texture[1]).setWidth(this.width)
    : phina.display.Sprite(
      options.topBorder||options.border,
      tileWidth,tileHeight).setRotation(0.0).setWidth(this.width);
    this.tLine= _tLine.addChildTo(this).setPosition(0,-this.height/2);
    // right line
    var _rLine = options.texture[4]
    ? phina.display.Sprite(options.texture[4]).setHeight(this.height)
    : phina.display.Sprite(
      options.rightBorder||options.border,
      tileWidth,tileHeight).setRotation(90.0).setWidth(this.height)
    this.rLine= _rLine.addChildTo(this).setPosition(this.width/2,0);
    // bottom line
    var _bLine = options.texture[6]
    ? phina.display.Sprite(options.texture[6]).setWidth(this.width)
    : phina.display.Sprite(options.bottomBorder||options.border
      ,tileWidth,tileHeight).setRotation(180.0).setWidth(this.width);
    this.bLine= _bLine.addChildTo(this).setPosition(0,this.height/2);
    // left line
    var _lLine = options.texture[3]
    ? phina.display.Sprite(options.texture[3]).setHeight(this.height)
    : phina.display.Sprite(
      options.leftBorder||options.border
      ,tileWidth,tileHeight).setRotation(270.0).setWidth(this.height);
    this.lLine= _lLine.addChildTo(this).setPosition(-this.width/2,0);
  // corner
    // left top corner
    var _ltCorner = options.texture[0]
    ? phina.display.Sprite(options.texture[0])
    : phina.display.Sprite(options.topLeftCorner
      ||options.corner1||options.topCorner||options.leftCorner||options.corner
      ,tileWidth,tileHeight).setRotation(0.0);
    this.ltCorner= _ltCorner.addChildTo(this).setPosition(-this.width/2,-this.height/2);
    // right top corner
    var _rtCorner = options.texture[2]
    ? phina.display.Sprite(options.texture[2])
    : phina.display.Sprite(options.topRightCorner
      ||options.corner2||options.topCorner||options.rightCorner||options.corne
      ,tileWidth,tileHeight).setRotation(90.0);
    this.rtCorner= _rtCorner.addChildTo(this).setPosition(this.width/2,-this.height/2);
    // left bottom corner
    var _lbCorner = options.texture[5]
    ? phina.display.Sprite(options.texture[5])
    : phina.display.Sprite(options.bottomLeftCorner
      ||options.corner2||options.bottomCorner||options.leftCorner||options.corner
      ,tileWidth,tileHeight).setRotation(270.0); 
    this.lbCorner= _lbCorner.addChildTo(this).setPosition(-this.width/2,this.height/2);
    // right bottom corner
    var _rbCorner = options.texture[7]
    ? phina.display.Sprite(options.texture[7])
    : phina.display.Sprite(options.bottomRightCorner
      ||options.corner1||options.bottomCorner||options.rightCorner||options.corner,
      tileWidth,tileHeight).setRotation(180.0);
    this.rbCorner= _rbCorner.addChildTo(this).setPosition(this.width/2,this.height/2);
  },
  _static: {
      defaults: {
        width: 200,
        height: 80,
        backgroundColor: 'transparent',
        fill: 'transparent',
        stroke: 'transparent',

        texture: [],

        corner: undefined,
        corner1: undefined,
        corner2: undefined,
        topCorner: undefined,
        bottomCorner: undefined,
        leftCorner: undefined,
        rightCorner: undefined,
        topLeftCorner: undefined,
        topRightCorner: undefined,
        bottomLeftCorner: undefined,
        bottomRightCorner: undefined,

        border: undefined,
        topBorder: undefined,
        bottomBorder: undefined,
        leftBorder: undefined,
        rightBorder: undefined,

        borderPattern: 'loop',
        tileWidth: 30,
        tileHeight: 30,
      },
    },
});


/**
 * @class phina.form.SpriteFrameButton
 * @extends phina.form.SpriteFrame
 */
phina.define('phina.form.SpriteFrameButton', {
  superClass:'phina.form.SpriteFrame',
  init: function(options){
    options = (options || {}).$safe(phina.form.SpriteFrameButton.defaults);
    this.superInit(options);
    this.setInteractive(true)
    .on('pointstart', function(){
      this.tweener.clear()
      .to({scaleX:0.9,scaleY:0.9},1)
    })
    .on('pointend', function(){
      this.tweener.clear()
      .to({scaleX:1.0,scaleY:1.0},100)
    })

    this._label = phina.display.Label({
      width:options.width, height:options.height,
      fill:options.fontColor, align:'center',
      text:options.text, fontSize:options.fontSize,
    }).addChildTo(this)
  },
  _static: {
    defaults: {
      width: 200,
      height: 80,
      backgroundColor: 'transparent',
      fill: 'transparent',
      stroke: 'transparent',

      text: 'Hello',
      fontColor: '#000',
      fontSize: 32,
      fontWeight: '',
      fontFamily: "'HiraKakuProN-W3'", // Hiragino or Helvetica,
    },
  },
  _accessor: {
    label: {
      set: function(v){
        this._label.text = v;
      },
      get: function(){ return this._label.text; }
    }
  }
});


/**
 * @class phina.form.SystemWindow
 * @extends phina.form.Window
 */
phina.define("phina.form.SystemWindow",{
    superClass: "phina.form.Window",
    init: function(param){
        param = (param||{}).$safe(phina.form.SystemWindow.defaults);
        this.superInit({fill:'transparent'}.$safe(param));
        this.bg=phina.display.RectangleShape({
          width:this.width, height:this.height,
          fill:param.fill, stroke:param.stroke
        }).addChildTo(this).setPosition(0,0).fromJSON({alpha:0.7});
        this.bodyFrame = phina.form.Window({
          width: this.width, height: this.height-20,
          fill: 'transparent', stroke: 'transparent',
        }).addChildTo(this).setPosition(0,10)
        this.titleBg=phina.display.RectangleShape({
          width:this.width, height:20,
          fill:param.fill, stroke:'transparent',
        }).addChildTo(this).setPosition(0,-param.height/2+10);
        this.titleLabel=phina.display.Label({
          text:param.title, fontSize:14,
          align:'center', baseline:'middle',
        }).addChildTo(this).setPosition(0,-param.height/2+10);
        this.titleFrame=phina.display.PathShape({
          stroke:'#FFF', strokeWidth: 1,
          paths: [Vector2(-this.width/2+5,0),Vector2(this.width/2-5,0)],
        }).addChildTo(this).setPosition(0,-param.height/2+20);
        if(param.animation){
          this.tweener
            .set({scaleX:0.9, scaleY:0.9, alpha:0.0})
            .to({scaleX:1.0, scaleY:1.0, alpha:1.0},200);
        }
        this.addChild = this.addChildToBodyFrame;
    },
    addChildToBodyFrame: function(child) {
      return this.bodyFrame.addChild(child);
    },
    _static:{
        defaults:{
            fill: "#000",
            stroke: "transparent",
            animation: true,
            title: ''
        }
    }
});


/**
 * @class phina.form.Table
 * Table
 * @extends phina.display.PlainElement
 */
phina.define("phina.form.Table", {
  superClass: "phina.display.VerticalStackLayout",
  init: function(param){
    var self = this;
    param=(param||{}).$safe(phina.form.Table.defaults);
    this.superInit(param);
  },
  insert:function(record){
    var self=this;
    self.addChild(phina.form.Table.Record({
      column: record,
    }),true);
    self.formatCell();
    return self;
  },
  formatCell:function(){
    var self = this;
    var maxWidth = [], maxHeight = [];
    self.children.map(function(r, i){
      r.children.map(function(d, j){
        maxHeight[i] = maxHeight[i] ? maxHeight[i].max(d.height) : d.height;
        maxWidth[j] = maxWidth[j] ? maxWidth[j].max(d.width) : d.width;
      })
    });
    self.children.map(function(r, i){
      r.children.map(function(d, j){
        d.minWidth = maxWidth[j];
        d.minHeight = maxHeight[i];
      })
    });
  },
  _static: {
    defaults: {
    }
  }
});

phina.define("phina.form.Table.Record", {
  superClass: "phina.display.HorizonStackLayout",
  init: function(param){
    var self = this;
    param=(param||{}).$safe(phina.form.Table.Record.defaults);
    this.superInit(param);

    param.column.map(function(v){
      var td = phina.form.Table.Data()
      .addChildTo(self)
      v(td);
    });
  },
  _static: {
    defaults: {
      fill:'transparent',stroke:'transparent',
      column:[],
    }
  }
});
phina.define("phina.form.Table.Data", {
  superClass: "phina.display.FlexibleElement",
  init: function(param){
    var self = this;
    param=(param||{}).$safe(phina.form.Table.Data.defaults);
    this.superInit(param);
    this.border = phina.display.RectangleShape({
      fill:param.fill, stroke:param.stroke,
      strokeWidth:param.strokeWidth,
      padding:0,
    }).fromJSON({ignoreAutoResize:true}).setPosition(0,0)
    .addChildTo(this)

    self.on('resized', function(){
      this.border.width = self.width;
      this.border.height = self.height;
    });
  },
  _static: {
    defaults: {
      fill:'transparent',stroke:'transparent',
      strokeWidth:1,
    }
  },
  _accessor: {
    stroke: {
      get:function(){ return this.border.stroke; },
      set:function(v){ this.border.stroke = v; }
    },
    fill: {
      get:function(){ return this.border.fill; },
      set:function(v){ this.border.fill = v; }
    },
    strokeWidth: {
      get:function(){ return this.border.strokeWidth; },
      set:function(v){ this.border.strokeWidth = v; }
    },
  }
});



/**
 * @class phina.form.TextAreaBox
 * @extends phina.display.RectangleShape
 */
phina.define("phina.form.TextAreaBox", {
    superClass: "phina.form.HiddenInput",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.TextAreaBox.defaults);
        this.superInit(param);

        self.bg = phina.display.RectangleShape({
            width:param.width, height:param.height,
            fill:param.fill, stroke:param.stroke,
            padding:2,
        }).setPosition(0,0)
        .fromJSON({
          clip: function(canvas){
            canvas.beginPath();
            var w = this.calcCanvasWidth();
            var h = this.calcCanvasHeight();
            canvas.roundRect(-w/2,-h/2,w,h,this.cornerRadius);
          }
        })
        .addChildTo(self)

        self.scrollArea = phina.form.ScrollArea({
            width:param.width, height:param.height,
            innerHeight:param.height, scrollbarWidth:param.fontSize,
        }).setPosition(0,0)
        .addChildTo(this)

        self.valueLabel = phina.display.LabelArea({
            align:param.align, baseline:param.baseline,
            width:param.width-self.scrollArea.scrollBar.width, height:param.height,
            text:param.value, fontSize:param.fontSize||this.height-4,
            fill:param.stroke, 
        }).setPosition(-self.scrollArea.scrollBar.width/2,0)
        .addChildTo(self.scrollArea)
        .setInteractive(true, 'rect')
        .on('click', self.changeValue.bind(self));
    },
    changeValue: function(param){
        var self = this;
        this.getRoot().app.pushScene(phina.form.ModalTextAreaDialog({
            okLabel: param.okLabel,
            cancelLabel: param.cancelLabel,
            value: self.value,
        }).on('change', function(e){
            self.value = e.value;
            self.flare('change', {value: e.value});
        }));
    },
    _static:{
        defaults:{
            align:'left', baseline:'top',
            width:100, height:20,
            value:'', fontSize:0,
            stroke:'#000', fill:'#FFF',

            okLabel:'決定', cancelLabel:'キャンセル'
        }
    },
    _accessor:{
        value:{
            set: function(val){
                this.formElement.value
                    = this.valueLabel.text
                    = val;
                this.scrollArea.innerHeight
                    = this.valueLabel.height
                    = this.height.max(
                        this.valueLabel.getLines().length*this.valueLabel.fontSize);
            },
            get: function(){ return this.formElement.value; }
        }        
    }
});


/**
 * @class phina.form.TextBox
 * @extends phina.display.RectangleShape
 */
phina.define("phina.form.TextBox", {
    superClass: "phina.form.Input",
    init: function(param){
        var self = this;
        param = (param||{}).$safe(phina.form.TextBox.defaults);
        this.superInit(param);
        self.setInteractive(true, 'rect');
        self.on('click', self.changeValue);

        self.formElement.type = 'text'
        self.formElement.value = param.value

        self.bg = phina.display.RectangleShape({
            width:param.width, height:param.height,
            fill:param.fill, stroke:param.stroke,
            padding:2,
        }).setPosition(0,0)
        .fromJSON({
          clip: function(canvas){
            canvas.beginPath();
            var w = this.calcCanvasWidth();
            var h = this.calcCanvasHeight();
            canvas.roundRect(-w/2,-h/2,w,h,this.cornerRadius);
          }
        })
        .addChildTo(self)
        self.valueLabel = phina.display.Label({ //TODO phina.display.Label2
            align:param.align, baseline:param.baseline,
            width:param.width, height:param.height,
            text:param.value, fontSize:param.fontSize||this.height-4,
            fill:param.stroke, 
        }).setPosition(-this.width/2,-this.height/2)
        .addChildTo(self.bg)
    },
    changeValue: function(param){
        var self = this;
        this.getRoot().app.pushScene(phina.form.ModalTextDialog({
            okLabel: param.okLabel,
            cancelLabel: param.cancelLabel,
            value: self.value,
        }).on('change', function(e){ 
            self.value = e.value;
            self.flare('change', {value: e.value});
        }));
    },
    syncInput: function(){
        this.valueLabel.text = this.value;
    },
    _static:{
        defaults:{
            align:'left', baseline:'top',
            width:100, height:20,
            value:'', fontSize:0,
            stroke:'#000', fill:'#FFF',

            okLabel:'決定', cancelLabel:'キャンセル'
        }
    },
    _accessor:{
        value:{
            set: function(val){
                this.formElement.value
                    = this.valueLabel.text
                    = val;
            },
            get: function(){ return this.formElement.value; }
        }        
    }
});


/**
 * @class phina.form.Window
 * @extends phina.display.RectangleShape
 */
phina.define("phina.form.Window", {
    superClass: "phina.display.RectangleShape",
    init: function(param){
        param = (param||{}).$safe(phina.form.Window.defaults);
        this.superInit(param);
    },
    clip: function(canvas){
        canvas.beginPath();
        var w = this.width;
        var h = this.height;
        var x = -w*this.origin.x;
        var y = -h*this.origin.y;
        canvas.roundRect(x,y,w,h,this.cornerRadius);
    },
    _static:{
        defaults:{
        }
    }
});
